/* eslint no-extend-native: 0 */

/**
 * Add object.create polyfill
 */
if (!Object.create) {

    Object.create = (() => {

        function F() { }

        return (obj) => {

            if (arguments.length !== 1) {

                throw new Error('Object.create implementation only accepts one parameter.');

            }
            F.prototype = obj;
            return new F();

        };

    })();

}

if (!Array.prototype.indexOf) {

    Array.prototype.indexOf = (searchElement, fromIndex) => {

        const { length } = this;

        if (this === undefined || this === null) {

            throw new Error('"this" is null or not defined');

        }

        fromIndex = +fromIndex || 0;

        if (Math.abs(fromIndex) === Infinity) {

            fromIndex = 0;

        }

        if (fromIndex < 0) {

            fromIndex += length;

            if (fromIndex < 0) {

                fromIndex = 0;

            }

        }

        for (; fromIndex < length; fromIndex += 1) {

            if (this[fromIndex] === searchElement) {

                return fromIndex;

            }

        }

        return -1;

    };

}

if (!String.prototype.endsWith) {

    String.prototype.endsWith = (search, thisLen) => {

        if (thisLen === undefined || thisLen > this.length) {

            thisLen = this.length;

        }
        return this.substring(thisLen - search.length, thisLen) === search;

    };

}

/* eslint-disable */
/**
 * Protect window.console method calls, e.g. console is not defined on IE
 * unless dev tools are open, and IE doesn't define console.debug
 *
 * Chrome 41.0.2272.118: debug,error,info,log,warn,dir,dirxml,table,trace,assert,count,markTimeline,profile,profileEnd,time,timeEnd,timeStamp,timeline,timelineEnd,group,groupCollapsed,groupEnd,clear
 * Firefox 37.0.1: log,info,warn,error,exception,debug,table,trace,dir,group,groupCollapsed,groupEnd,time,timeEnd,profile,profileEnd,assert,count
 * Internet Explorer 11: select,log,info,warn,error,debug,assert,time,timeEnd,timeStamp,group,groupCollapsed,groupEnd,trace,clear,dir,dirxml,count,countReset,cd
 * Safari 6.2.4: debug,error,log,info,warn,clear,dir,dirxml,table,trace,assert,count,profile,profileEnd,time,timeEnd,timeStamp,group,groupCollapsed,groupEnd
 * Opera 28.0.1750.48: debug,error,info,log,warn,dir,dirxml,table,trace,assert,count,markTimeline,profile,profileEnd,time,timeEnd,timeStamp,timeline,timelineEnd,group,groupCollapsed,groupEnd,clear
 */
(function() {
    // Union of Chrome, Firefox, IE, Opera, and Safari console methods
    var methods = ["assert", "cd", "clear", "count", "countReset",
      "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed",
      "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd",
      "select", "table", "time", "timeEnd", "timeStamp", "timeline",
      "timelineEnd", "trace", "warn"];
    var length = methods.length;
    var console = (window.console = window.console || {});
    var method;
    var noop = function() {};
    while (length--) {
      method = methods[length];
      // define undefined methods as noops to prevent errors
      if (!console[method])
        console[method] = noop;
    }

  })();




// WEBPACK FOOTER //
// ./scripts/common/polyfill.js